document.addEventListener("DOMContentLoaded", function () {
var Shopify = Shopify || {};
// Shopify.money_format = "${{amount}}";
Shopify.money_format = window.Shopify?.money_format || "{{amount}}";
const DEBUG = false;
// --- Money Formatter ---
Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }
  const match = formatString.match(placeholderRegex);
  if (!match) return '';
  const amountType = match[1];
  switch (amountType) {
    case 'amount': return formatString.replace(placeholderRegex, formatWithDelimiters(cents, 2));
    case 'amount_no_decimals': return formatString.replace(placeholderRegex, formatWithDelimiters(cents, 0));
    case 'amount_with_comma_separator': return formatString.replace(placeholderRegex, formatWithDelimiters(cents, 2, '.', ','));
    case 'amount_no_decimals_with_comma_separator': return formatString.replace(placeholderRegex, formatWithDelimiters(cents, 0, '.', ','));
    default: return '';
  }
};
// Initialize with in-memory storage instead of localStorage
let product_list1 = [];
let tote_product1 = null;
// Try to restore from localStorage if available (for backward compatibility)
try {
  product_list1 = JSON.parse(localStorage.getItem("selected_products")) || [];
  tote_product1 = JSON.parse(localStorage.getItem("tote_product1")) || JSON.parse(localStorage.getItem("tote_product")) || null;
} catch (e) {
  console.warn("localStorage not available, using in-memory storage");
}
// function saveToStorage() {
//   try {
//     localStorage.setItem("selected_products", JSON.stringify(product_list1));
//     if (tote_product1) {
//       localStorage.setItem("tote_product1", JSON.stringify(tote_product1));
//       localStorage.setItem("tote_product", JSON.stringify(tote_product1)); // Backward compatibility
//     } else {
//       localStorage.removeItem("tote_product1");
//       localStorage.removeItem("tote_product");
//     }
//   } catch (e) {
//     // Storage not available, continue with in-memory
//   }
// }
function saveToStorage() {
  try {
    localStorage.setItem("selected_products", JSON.stringify(product_list1));
    if (tote_product1) {
      const toteData = { 
        id: parseInt(tote_product1.id, 10), 
        img: tote_product1.img,
        priceCents: tote_product1.priceCents || 0
      };
      localStorage.setItem("tote_product1", JSON.stringify(toteData));
      localStorage.setItem("tote_product", JSON.stringify(toteData));
    } else {
      localStorage.removeItem("tote_product1");
      localStorage.removeItem("tote_product");
    }
  } catch (e) {}
}
function setupHoverAction() {
  const cursorEffect = document.getElementById('cursor-effect');
  
  document.querySelectorAll('.tc-list').forEach((tcItem, index) => {
    const varId = tcItem.getAttribute('var-id');
    const isAvailable = tcItem.getAttribute('data-available');

    // ✅ Sold-out totes: show "Sold Out" on hover, remove hover-section class
    if (isAvailable === 'false') {
      tcItem.querySelectorAll('.hover-section').forEach(section => {
        section.setAttribute('data-value', 'Sold Out');
        section.classList.remove('hover-section');
      });
      tcItem.querySelector('.tc-img')?.classList.remove('hover-section');
      return;
    }

    const isMatch = [...document.querySelectorAll('.tote-product')]
      .some(product => product.getAttribute('pro-id') === varId);
    
    const valueText = isMatch ? 'Remove' : 'Add to Kit';
    tcItem.querySelectorAll('.hover-section')
      .forEach(section => section.setAttribute('data-value', valueText));
  
    if (index === 0 && cursorEffect) {
      cursorEffect.textContent = valueText;
    }
  });
}
function updateSnippetCardProducts() {
  const cursorEffect = document.getElementById('cursor-effect');
  
  document.querySelectorAll('.snippet-card-product').forEach((snippetCard, index) => {
    const productId = snippetCard.getAttribute('data-b-var');
    const productImagesElement = snippetCard.querySelector('.product-images');
    if (!productId || !productImagesElement) {
      return;
    }
    if (snippetCard.getAttribute('data-available') === 'false') {
      productImagesElement.setAttribute('data-value', 'Sold Out');
      productImagesElement.classList.remove('hover-section');
      return;
    }
    const isSelected = [...document.querySelectorAll('.single_selected')]
      .some(el => el.getAttribute('data-vid') === productId);
    const valueText = isSelected ? 'Remove' : 'Add to Kit';
    console.log('valueText', valueText);
    productImagesElement.setAttribute('data-value', valueText);
    if (index === 0 && cursorEffect) {
      cursorEffect.textContent = valueText;
    }
  });
  strikeThrough();
}
function addHoverButton() {
  document.querySelectorAll(".main_selected .tote-product").forEach((toteSelectedImgWrapper) => {
    const toteImg = toteSelectedImgWrapper.querySelector("img");
    const toteHoverTarget = toteSelectedImgWrapper.querySelector(".img-div");
    const toteSrc = toteImg?.getAttribute("src");
    
    if (toteSrc && toteSrc.trim() !== "") {
      toteHoverTarget?.classList.add("hover-section");
      toteHoverTarget?.setAttribute("data-value", "remove");
    } else {
      toteHoverTarget?.classList.remove("hover-section");
      toteHoverTarget?.removeAttribute("data-value");
    }
  });
}
// window.strikeThrough=()=> {
//   let strikeThroughPriceWrap = document.querySelector(".strikeThrough");
//   let strikeThroughPriceEl = document.querySelector(".strikeThrough .sub_total");
//   if (!strikeThroughPriceWrap || !strikeThroughPriceEl) return; // safety check
//   let tote_product=JSON.parse(localStorage.getItem('tote_product'));
//   let selected_product=JSON.parse(localStorage.getItem('selected_products'));
//   if (Array(tote_product).length>=1 && Array(tote_product)[0]!=null && selected_product.length === 4) {
  
//     let originalPriceText = strikeThroughPriceEl.textContent.replace(/[^\d.-]/g, '');
//     let originalPrice = parseFloat(originalPriceText);
//     let updatedPriceCents = Math.round((originalPrice + 25) * 100);
//     let formattedPrice = Shopify.formatMoney(updatedPriceCents, Shopify.money_format);
//     strikeThroughPriceWrap.classList.remove("hide");
//     strikeThroughPriceEl.textContent = formattedPrice;
//   } else {
//     strikeThroughPriceWrap.classList.add("hide");
//   }
// }
window.strikeThrough = () => {
  const strikeThroughPriceWrap = document.querySelector(".strikeThrough");
  const strikeThroughPriceEl = document.querySelector(".strikeThrough .sub_total");
  if (!strikeThroughPriceWrap || !strikeThroughPriceEl) return;

  const tote = JSON.parse(localStorage.getItem('tote_product') || 'null');
  const selected = JSON.parse(localStorage.getItem('selected_products') || '[]');

  if (tote && selected.length === 4) {
    const productTotalCents = selected.reduce((sum, p) => sum + (p.priceCents || 0), 0);
    const totePriceCents = tote.priceCents || 0;
    
    const undiscountedCents = productTotalCents + totePriceCents; // tote + 4 products
    strikeThroughPriceEl.innerHTML = Shopify.formatMoney(undiscountedCents, Shopify.money_format);
    strikeThroughPriceWrap.classList.remove("hide");
  } else {
    strikeThroughPriceWrap.classList.add("hide");
  }
};
function onHoverRemove() {
  // Handle grid image hover sections
  document.querySelectorAll(".grid-imagebox.hover-section").forEach((element) => {
    const varId = element.getAttribute("remove-var-id");
    if (varId) {
      element.setAttribute("data-value", "remove");
    }
  });
}
function updateSelectedProducts() {
  product_list1 = product_list1.filter(Boolean).slice(0, 4);
  // Update selected product slots
  document.querySelectorAll(".single_selected").forEach((slot, i) => {
    const item = product_list1[i];
    if (item) {
      slot.querySelector(".selected_img img").src = item.img;
      slot.querySelector(".selected_info h6").textContent = item.title;
      slot.querySelector(".selected_info span").textContent = item.price;
      slot.dataset.vid = item.id;
      slot.dataset.qty = item.quantity;
      product_list1[i].bundleIndex = i + 1;
    } else {
      slot.querySelector(".selected_img img").src = "";
      slot.querySelector(".selected_info h6").textContent = "Select a product";
      slot.querySelector(".selected_info span").textContent = "";
      slot.removeAttribute("data-vid");
      slot.removeAttribute("data-qty");
    }
  });
  
  // Update product grid items
  document.querySelectorAll(".product-item").forEach(product => {
    const selectBtn = product.querySelector(".select_pro_button");
    if (!selectBtn) return;
    
    const varid = selectBtn.dataset.variantid || selectBtn.getAttribute("data-variantId");
    const gridImg = product.querySelector(".grid-imagebox");
    const card = product.querySelector(".snippet-card-product");
    const prourl = product.querySelector(".grid-imagebox a");
    const setprourl = card ? card.getAttribute("pro-url") : "";
    const idxEl = product.querySelector(".add-indexing");
    const cursorEffect = document.getElementById('cursor-effect');
    const isAvailable = selectBtn.getAttribute("data-available");
    if (isAvailable === "false") {
      if (card) card.classList.add("sold-out-card");
      if (gridImg) {
        gridImg.classList.remove("hover-section");
        gridImg.removeAttribute("data-value");
        gridImg.removeAttribute("remove-var-id");
      }
      return; // skip rest of loop for this product
    }
    const index = product_list1.findIndex(p => p.id === varid);
    // Handle cursor effect mouseout
    if (gridImg && cursorEffect) {
      gridImg.addEventListener('mouseout', () => {
        cursorEffect.style.display = 'none';
      });
    }
    if (index !== -1) {
      if (idxEl) {
        idxEl.textContent = index + 1;
        idxEl.classList.add("active-index");
      }
      if (gridImg) {
        gridImg.classList.add("hover-section");
        gridImg.dataset.value = "remove";
        gridImg.setAttribute("remove-var-id", varid);
      }
      if (card) card.classList.add("active-buid-pro");
      if (prourl) prourl.href = "#";
    } else {
      if (idxEl) {
        idxEl.textContent = "";
        idxEl.classList.remove("active-index");
      }
      if (gridImg) {
        gridImg.classList.remove("hover-section");
        gridImg.removeAttribute("data-value");
        gridImg.removeAttribute("remove-var-id");
      }
      if (card) card.classList.remove("active-buid-pro");
      if (prourl && setprourl) prourl.href = setprourl;
    }
  });
  // Update selected products hover states
  document.querySelectorAll(".main_selected .single_selected").forEach((selectedImgWrapper) => {
    const img = selectedImgWrapper.querySelector("img");
    const hoverTarget = selectedImgWrapper.querySelector(".selected_img");
    const rawSrc = img?.getAttribute("src")?.trim();
    
    if (rawSrc) {
      hoverTarget.classList.add("hover-section");
      hoverTarget.setAttribute("data-value", "remove");
    } else {
      hoverTarget.classList.remove("hover-section");
      hoverTarget.removeAttribute("data-value");
    }
  });
  // Update total amount
  // const totalAmount = product_list1.reduce((sum, p) => sum + parseFloat(p.price.replace(/[^\d.-]/g, '')), 0);
  // document.querySelectorAll(".sub_total").forEach(span => {
  //   span.textContent = Shopify.formatMoney(totalAmount * 100, Shopify.money_format);
  // });
  const totalCents = product_list1.reduce((sum, p) => sum + (p.priceCents || 0), 0);
  document.querySelectorAll(".sub_total").forEach(span => {
    span.innerHTML  = Shopify.formatMoney(totalCents, Shopify.money_format);
  });
  saveToStorage();
  validateCartButton();
  onHoverRemove();
  setupHoverAction();
  updateSnippetCardProducts();
  addHoverButton();
  strikeThrough();
}
function validateCartButton() {
  const btn = document.querySelector(".box_bottom .button.add_to_cart");
  if (!btn) return;
  if (tote_product1 && product_list1.length === 4) {
    btn.classList.remove("disabled");
    btn.removeAttribute("disabled");
  } else {
    btn.classList.add("disabled");
    btn.setAttribute("disabled", "true");
  }
}
  
function handleProductSelection(variantId) {
  const existingIndex = product_list1.findIndex(item => String(item.id) === String(variantId));
  if (existingIndex !== -1) {
    // Remove product
    product_list1.splice(existingIndex, 1);
    if (DEBUG) console.log("Removed product:", variantId);
  } else {
    // Add product - changed from 4 to 3 products max
    if (product_list1.length >= 4) {
      strikeThrough();
      alert("Sorry, you can't add more than 4 products.");
      return false;
    }
    const productItem = document.querySelector(`[data-variantId="${variantId}"], [data-variantid="${variantId}"]`)?.closest(".product-item");
    if (!productItem) {
      console.error("Product item not found for variant:", variantId);
      return false;
    }
    const selectBtn = productItem.querySelector(".select_pro_button");
    const titleEl = productItem.querySelector(".grid-meta .grid-title a");
    const priceEl = productItem.querySelector(".grid-meta-price .regular-price") || productItem.querySelector(".grid-meta-price");
    if (!productItem || !selectBtn || !titleEl || !priceEl) {
      console.error("Required product elements not found");
      return false;
    }
    if (selectBtn.getAttribute("data-available") === "false") {
      alert("This product is sold out in your region and cannot be added to the kit.");
      return false;
    }
    const bundleIndex = product_list1.length + 1;
    const newProduct = {
      id: parseInt(variantId, 10),
      img: selectBtn.getAttribute("data-productImage"),
      title: titleEl.textContent.trim(),
      price: priceEl.textContent.trim(),
      priceCents: parseInt(selectBtn.getAttribute("data-price-cents") || "0", 10),
      quantity: 1,
      bundleIndex: bundleIndex
    };
    product_list1.push(newProduct);
    if (DEBUG) console.log("Added product:", newProduct);
  }
  updateSelectedProducts();
  return true;
}
function handleToteSelection(selectedId, selectedImage, checkRadio = false) {
  // tote_product1 = { id: selectedId, img: selectedImage };
  const tcItem = document.querySelector(`.tc-list[var-id="${selectedId}"]`) 
               || document.querySelector(`.tc-list input[value="${selectedId}"]`)?.closest('.tc-list');
  
  let totePriceCents = 0;
  if (tcItem) {
    const moneyEl = tcItem.querySelector('.regular-price .money');
    if (moneyEl) {
      const rawText = moneyEl.textContent.replace(/[^\d.,]/g, '').trim();
      const normalized = rawText.includes(',') && rawText.indexOf(',') === rawText.length - 3
        ? rawText.replace('.', '').replace(',', '.')
        : rawText.replace(',', '');
      totePriceCents = Math.round(parseFloat(normalized) * 100);
    }
  }

  tote_product1 = { 
    id: parseInt(selectedId, 10), 
    img: selectedImage,
    priceCents: totePriceCents
  };
  saveToStorage();
  const toteContainer = document.querySelector(".tote-product");
  if (toteContainer) {
    toteContainer.setAttribute("pro-id", selectedId);
    const img = toteContainer.querySelector("img");
    if (img) img.setAttribute("src", selectedImage);
  }
  document.querySelectorAll(".toitery-add").forEach(btn => btn.classList.remove("active"));
  const activeButton = document.querySelector(`.toitery-add[data-variantId="${selectedId}"], .toitery-add[data-variantid="${selectedId}"]`);
  if (activeButton) activeButton.classList.add("active");
  if (checkRadio) {
    const radioInput = document.querySelector(`input[type=radio][value="${selectedId}"]`);
    if (radioInput) radioInput.checked = true;
  }
  
  validateCartButton();
  setupHoverAction();
  updateSnippetCardProducts();
  addHoverButton();
  strikeThrough();
}
// Event delegation for better performance and reliability
document.addEventListener('click', function(e) {
  // Handle grid image box clicks
  if (e.target.closest('.grid-imagebox')) {
    e.preventDefault();
    e.stopPropagation();
    
    const gridBox = e.target.closest('.grid-imagebox');
    const productItem = gridBox.closest('.product-item');
    
    if (!productItem) return;
    
    const selectBtn = productItem.querySelector('.select_pro_button');
    if (!selectBtn) return;

    if (selectBtn.getAttribute('data-available') === 'false') return;
    
    const variantId = selectBtn.dataset.variantid || selectBtn.getAttribute('data-variantId');
    if (!variantId) return;
    
    // Check if it's in remove mode
    if (gridBox.classList.contains('hover-section') && gridBox.getAttribute('data-value') === 'remove') {
      const removeVarId = gridBox.getAttribute('remove-var-id');
      if (removeVarId) {
        product_list1 = product_list1.filter(item => String(item.id) !== String(removeVarId));
        updateSelectedProducts();
        return;
      }
    }
    
    handleProductSelection(variantId);
  }
  
  // Handle select product button clicks
  if (e.target.closest('.select_pro_button')) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = e.target.closest('.select_pro_button');

    if (button.getAttribute('data-available') === 'false') return;
    const variantId = button.dataset.variantid || button.getAttribute('data-variantId');
    
    if (!variantId) return;
    
    handleProductSelection(variantId);
  }
  
  // Handle selected product removal
  if (e.target.closest('.single_selected[data-vid]')) {
    const selected = e.target.closest('.single_selected');
    const variantId = selected.dataset.vid;
    
    if (variantId) {
      product_list1 = product_list1.filter(p => String(p.id) !== String(variantId));
      updateSelectedProducts();
    }
  }
  
  // Handle tote product removal
  if (e.target.closest('.tote-product .img-div.hover-section')) {
    tote_product1 = null;
    const tote = document.querySelector('.tote-product');
    if (tote) {
      tote.removeAttribute('pro-id');
      const img = tote.querySelector('img');
      if (img) img.src = '';
    }
    document.querySelectorAll('.toitery-add.active').forEach(btn => btn.classList.remove('active'));
    updateSelectedProducts();
  }
  
  // Handle tote selection via radio buttons
  // if (e.target.closest('.tc-list input[type=radio]')) {
  //   const input = e.target.closest('input[type=radio]');
  //   const productItem = input.closest('.tc-list');
  //   const selectedImage = productItem.querySelector('img').getAttribute('src');
  //   const selectedId = input.value;
  //   handleToteSelection(selectedId, selectedImage, false);
  // }

  // REPLACE WITH:
if (e.target.closest('.tc-list input[type=radio]')) {
  const input = e.target.closest('input[type=radio]');
  const productItem = input.closest('.tc-list');
  const selectedImage = productItem.querySelector('img').getAttribute('src');
  const selectedId = parseInt(input.value, 10);
  console.log("Radio tote selected - ID:", selectedId);
  if (!selectedId || isNaN(selectedId)) {
    console.error("Invalid tote ID from radio:", input.value);
    return;
  }
  handleToteSelection(selectedId, selectedImage, false);
}
  
  // Handle tote selection via buttons
  if (e.target.closest('.toitery-add')) {
    e.preventDefault();
    const button = e.target.closest('.toitery-add');
    if (button.getAttribute('data-available') === 'false') return;
    const isActive = button.classList.contains('active');
    const productItem = button.closest('.tc-list');
    const selectedImage = productItem.querySelector('img').getAttribute('src');

    // Try all possible sources for variant ID
    const rawId = productItem.getAttribute('var-id') 
      || button.getAttribute('data-variantId')
      || button.getAttribute('data-variantid')
      || productItem.querySelector('input[type=radio]')?.value;
    const selectedId = parseInt(rawId, 10);
    
    console.log("Tote selected - raw ID:", rawId, "parsed:", selectedId);
    
    if (!selectedId || isNaN(selectedId)) {
      console.error("Could not get valid variant ID for tote. productItem:", productItem);
      return;
    }
    if (!isActive) {
      handleToteSelection(selectedId, selectedImage, true);
      button.classList.add('active');
    } else {
      tote_product1 = null;
      const toteContainer = document.querySelector('.tote-product');
      if (toteContainer) {
        toteContainer.removeAttribute('pro-id');
        const img = toteContainer.querySelector('img');
        if (img) img.setAttribute('src', '');
      }
      button.classList.remove('active');
      validateCartButton();
      addHoverButton();
      setupHoverAction();
      updateSnippetCardProducts();
      strikeThrough();
    }
  }
  
  // Handle tc-img clicks
  if (e.target.closest('.tc-list .tc-img')) {
    e.preventDefault();
    const link = e.target.closest('.tc-img');
    const productItem = link.closest('.tc-list');

    // ✅ Block clicks on sold-out tote images
    if (productItem.getAttribute('data-available') === 'false') return;

    const quickAddBtn = productItem.querySelector('.quick-add, .toitery-add');
    if (quickAddBtn) {
      quickAddBtn.click();
    }
  }
  
  // Handle add to cart
  if (e.target.closest('.add_to_cart')) {
    e.preventDefault();
    
    if (!tote_product1 || product_list1.length < 4) {
      alert('Please select a tote and at least 4 products.');
      return;
    }
    // const formData = [
    //   { id: tote_product1.id, quantity: 1 },
    //   ...product_list1.map(p => ({ id: p.id, quantity: p.quantity }))
    // ];
    // fetch('/cart/add.js', {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ items: formData })
    // })
    console.log("tote_product1:", tote_product1);
    console.log("product_list1:", product_list1);

    const formData = [
      { id: parseInt(tote_product1.id, 10), quantity: 1 },
      ...product_list1.map(p => ({ id: parseInt(p.id, 10), quantity: p.quantity }))
    ];

    console.log("formData being sent:", JSON.stringify(formData));

    // Validate all IDs are valid numbers before sending
    const hasInvalidIds = formData.some(item => isNaN(item.id) || item.id <= 0);
    if (hasInvalidIds) {
      console.error("Invalid variant IDs in cart payload:", formData);
      alert("Something went wrong. Please refresh and try again.");
      return;
    }

    console.log("Cart payload:", JSON.stringify({ items: formData }));

    fetch('/cart/add.js', {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ items: formData })
})
  .then(res => {
    if (!res.ok) {
      return res.json().then(err => {
        console.error("Cart error details:", JSON.stringify(err));
        throw new Error(err.description || "Failed to add to cart");
      });
    }
    return res.json();
  })
  .then(() => {
    try {
      // localStorage.removeItem("selected_products");
      // localStorage.removeItem("tote_product");
      // localStorage.removeItem("tote_product1");
    } catch (e) {
      // Storage not available
    }
    // product_list1 = [];
    // tote_product1 = null;
    
    if (typeof load_cart === 'function') {
      load_cart();
    }
    
    document.body.classList.add("open-drawer");
  })
  .catch(err => console.error("Cart error:", err));
  }
});
// Handle cursor effect mouseout for tote images
document.addEventListener('mouseout', function(e) {
  if (e.target.closest('.img-div')) {
    const cursorEffect = document.getElementById('cursor-effect');
    if (cursorEffect) {
      cursorEffect.style.display = 'none';
    }
  }
});
// Disable active links
function disableActiveLinks() {
  document.querySelectorAll(".active_link").forEach(link => link.setAttribute("href", ""));
}
// Initialize on page load
function restoreKitOnPageLoad() {
  product_list1 = product_list1.filter(savedProduct => {
    const btn = document.querySelector(
      `[data-variantId="${savedProduct.id}"], [data-variantid="${savedProduct.id}"]`
    );
    if (!btn) return false; // product no longer on page, remove it
    return btn.getAttribute('data-available') !== 'false';
  });
  // Restore tote product if exists
  if (tote_product1) {
    const toteContainer = document.querySelector(".tote-product");
    if (toteContainer) {
      toteContainer.setAttribute("pro-id", tote_product1.id);
      const img = toteContainer.querySelector("img");
      if (img) img.setAttribute("src", tote_product1.img);
    }
    const selectedRadio = document.querySelector(`input[type=radio][value="${tote_product1.id}"]`);
    if (selectedRadio) selectedRadio.checked = true;
    document.querySelectorAll(".toitery-add").forEach(btn => btn.classList.remove("active"));
    const activeButton = document.querySelector(`.toitery-add[data-variantId="${tote_product1.id}"], .toitery-add[data-variantid="${tote_product1.id}"]`);
    if (activeButton) activeButton.classList.add("active");
  }
  
  updateSelectedProducts();
}
// Run initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    restoreKitOnPageLoad();
    setTimeout(disableActiveLinks, 200);
  });
} else {
  restoreKitOnPageLoad();
  setTimeout(disableActiveLinks, 200);
}
})
